import { defineMessages } from 'react-intl';

/** Shared chrome copy for the connect-alternatives dialog. */
export const connectAlternativesMessages = defineMessages({
  dialogTitle: {
    id: 'socialExport.connectAlternatives.dialogTitle',
    defaultMessage: 'Elige como conectar a {platform}',
  },
  permissionsLabel: {
    id: 'socialExport.connectAlternatives.permissionsLabel',
    defaultMessage: 'Permisos',
  },
  recommendedBadge: {
    id: 'socialExport.connectAlternatives.recommendedBadge',
    defaultMessage: 'Recomendado',
  },
  redirecting: {
    id: 'socialExport.connectAlternatives.redirecting',
    defaultMessage: 'Redirigiendo a {platform} para conectar...',
  },
});
